import { FC, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ContractStatus, { Signatory } from '../app-project-overview-item/ContractStatus';
import { serviceSalesOrgApplication } from '../../services/salesOrgApplicationService';
import { Loading } from '../../components/shared';
import { ContractStatusType } from '../../models/global.model';
import { SalesOrganizationApplicationStatus } from '../page-bid-request-list/types';
import { useTranslation, Trans } from 'react-i18next';
import { LeftBarWrapper } from '../page-registration/LeftBarWrapper';
import Card from '../../components/shared/Card/card';

type SalesOrgApplication = {
  status: ContractStatusType,
  documentId: string,
  organizationNumber: string,
  recipients: Signatory[],
  orgSlug?: string,
  applicationStatus?: SalesOrganizationApplicationStatus,
  decision?: 'APPROVED' | 'REJECTED',
}

type Params = {
  code: string,
};

type RouteTypes = RouteComponentProps<Params, Record<string, unknown>>;

type Props = {
  history: RouteTypes['history'];
  location: RouteTypes['location'];
  match: RouteTypes['match'];
};

export const PageContractStatus: FC<Props> = ({ location, history, match }) => {
  const [t] = useTranslation('contract');
  location;
  history;

  const [sendAgain, setSendAgain] = useState({});
  const [salesOrgApplication, setSalesOrgApplication] = useState<SalesOrgApplication>();
  const [loading, setLoading] = useState(true);
  const { code } = match.params;

  useEffect(() => {
    if (code) {
      (async () => {
        const salesOrgApplication =  await serviceSalesOrgApplication.getSalesOrgApplication(code);
        setSalesOrgApplication(salesOrgApplication);
        setLoading(false);
      })()
    }
  }, [code]);

  return (
    <LeftBarWrapper>
      <div className="align-center bt-w60">
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Loading type='inline' />
          </div>
        ) : salesOrgApplication && (
          <>
            <h3 style={{fontSize: '16px', fontWeight: 500, color: 'var(--gray-900)'}}>
            </h3>
            <Card
              title={t('pageTitle', 'Du har ansökt om leverantörskonto för {{organizationNumber}}', { organizationNumber: salesOrgApplication.organizationNumber })}
              style={{ width: '600px' }}
            >
              <ContractStatus
                loading={false}
                signatories={salesOrgApplication.recipients}
                status={salesOrgApplication.status}
                sendAgain={sendAgain}
                setSendAgain={setSendAgain}
                error={''}
                documentId={salesOrgApplication.documentId}
                organizationNumber={salesOrgApplication.organizationNumber}
              />
            </Card>
            
            {salesOrgApplication.orgSlug && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '20px' }}>
                <span style={{ fontSize: '14px', color: 'var(--gray-700)' }}>{t('successMessage', 'Leverantörskontot har skapats och en inbjudan har skickats till din e-post.')}</span>
              </div>
            )}
            {!salesOrgApplication.orgSlug && salesOrgApplication.applicationStatus === 'AWAITING_MANUAL_APPROVAL' && !salesOrgApplication.decision && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '20px' }}>
                <span style={{ fontSize: '14px', color: 'var(--gray-700)' }}>{t('awaitingApprovalMessage', 'Din ansökan om leverantörskonto behöver nu godkännas manuellt.')}</span>
              </div>
            )}
            {!salesOrgApplication.orgSlug && salesOrgApplication.decision === 'REJECTED' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '20px' }}>
                <span style={{ fontSize: '14px', color: 'var(--gray-700)' }}><Trans t={t} i18nKey="rejectedMessage" components={{a: <a/>}} /></span>
              </div>
            )}
            {!salesOrgApplication.orgSlug && salesOrgApplication.applicationStatus === 'SIGNED' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '20px' }}>
                <span style={{ fontSize: '14px', color: 'var(--gray-700)' }}>{t('errorMessage', 'Leverantörskontot kunde inte skapas. En organisation med det organisationsnumret fanns redan i Accurator.')}</span>
              </div>
            )}
          </>
        )}
      </div>
    </LeftBarWrapper>
  )
};
